import { PaymentMethodsRepository } from '@core/repositories/payment-methods.repository';
import { PaymentMethod } from '@shared/interfaces/payment-method';
import { Observable, of, throwError } from 'rxjs';

interface ResultPaymentMethods {
  id: number;
  attributes: {
    name: string;
  }
}

export class FakePaymentMethodsRepository implements PaymentMethodsRepository {
  url: string;

  dataPaymentMethods: Array<ResultPaymentMethods> = [
    {
      id: 301,
      attributes: {
        name: 'Efectivo'
      }
    },
    {
      id: 401,
      attributes: {
        name: 'Tarjeta de credito'
      }
    },
    {
      id: 501,
      attributes: {
        name: 'Cuenta de ahorros'
      }
    }
  ];

  paymentMethods = {
    data: this.dataPaymentMethods
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.paymentMethods);
  }

  add(paymentMethod: PaymentMethod): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(paymentMethod: PaymentMethod): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
